import { render, staticRenderFns } from "./CourseAddToCartBlock.vue?vue&type=template&id=adaa7776&"
import script from "./CourseAddToCartBlock.vue?vue&type=script&lang=ts&"
export * from "./CourseAddToCartBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports